@for (opt of options | sortBy:'asc':'sort'; track opt) {
<mbnm-builder-tile #tiles [title]="opt.title" [collapsible]="false" [helpInfo]="opt.helpInfo">
  <mbnm-builder-option class="content" [choices]="opt.choices" [value]="opt.selection" (selectionChanged)="onSelectionChanged($event, opt)"></mbnm-builder-option>
</mbnm-builder-tile>
}
